import { render, staticRenderFns } from "./sortlist.vue?vue&type=template&id=4db067a8&scoped=true&"
import script from "./sortlist.vue?vue&type=script&lang=js&"
export * from "./sortlist.vue?vue&type=script&lang=js&"
import style0 from "./sortlist.vue?vue&type=style&index=0&id=4db067a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db067a8",
  null
  
)

export default component.exports